module.exports = __webpack_public_path__ + "static/media/point+100.7f31e91d.png";